<template>
  <div class="wrap">
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
              <md-icon>textsms</md-icon>
            </div>
            <h4 class="title">
              Enquiries
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-size-20">
                <enquiry-filter @filterEnquiries="filterEnquiries" />
              </div>
              <div class="md-layout-item md-size-80">
                <md-toolbar md-elevation="0" class="md-transparent md-dense">
                  <div class="md-toolbar-section-end">
                    <md-button
                      class="md-icon-button md-dense md-primary md-round"
                      @click="addEnquiry"
                    >
                      <md-icon>add</md-icon>
                      <md-tooltip md-direction="top"
                        >Create a new Enquiry</md-tooltip
                      >
                    </md-button>
                  </div>
                </md-toolbar>

                <enquiry-list
                  :enquiries="enquiries"
                  @deleteEnquiry="deleteEnquiry"
                />
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
    <enquiry-dialog
      :enquiryDialog="showEnquiryDialog"
      @cancel="showEnquiryDialog = false"
      @enquiry-created="newEnquiry"
    />
  </div>
</template>

<script>
import enquiryApi from "@/services/api/enquiry";
import _filter from "lodash/filter";

import EnquiryList from "./EnquiryList.vue";
import EnquiryFilter from "./EnquiryFilter.vue";
import EnquiryDialog from "./EnquiryDialog.vue";

export default {
  data() {
    return {
      enquiries: [],
      showEnquiryDialog: false
    };
  },

  components: {
    EnquiryList,
    EnquiryFilter,
    EnquiryDialog
  },

  methods: {
    getEnquiries() {
      enquiryApi.getEnquiries().then(response => {
        this.enquiries = response.data;
      });
    },

    filterEnquiries() {
      this.getEnquiries();
    },

    addEnquiry() {
      this.showEnquiryDialog = true;
    },

    newEnquiry(enquiry) {
      this.showNewBookingDialog = false;
      this.$router.push({
        name: "Enquiry Overview",
        params: { id: enquiry.id }
      });
    },

    deleteEnquiry(enquiry) {
      enquiryApi.deleteEnquiry(enquiry.id).then(response => {
        this.enquiries = _filter(this.enquiries, function(item) {
          return item.id !== enquiry.id;
        });

        this.$notify({
          timeout: 2500,
          message: "Deleted.",
          icon: "cancel",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "danger"
        });
      });
    }
  },

  mounted() {
    this.getEnquiries();
  }
};
</script>
